import React from "react";
import {harborService} from "../jwt/_services/xailing/harborService";

export const harborProvider = {
	getOptions,
	getItem,
};

async function getOptions() {
	try {
		const listItems = await harborService.search(0,100);
		return listItems.data.map((itemData) => {
			const {id, code, name} = itemData
			return (
				{
					id: id,
					value: code,
					label: <div><label>{name}</label></div>
				}
			)
		});
	} catch (error) {
		console.log(error.message)
	}
}

async function getItem(id) {
	try {
		const item = await harborService.getItem(id);

		return (
			{
				id: item.id,
				value: item.code,
				label: <div><label>{item.name}</label></div>
			}
		);
	} catch (error) {
		console.log(error.message)
	}
}